// Common
import githubMark from './GitHub-Mark.png'
import linkedinMark from './LinkedIn-Mark.png'

import multiModalFlat from './multiModalFlat.jpg'
import deskRenderIso from './deskRenderIso.png'
import wordPortraitThumb from './wordPortraitThumb.png'
import districtIso from './3D-district-iso.jpg'
import districtTop from './3D-district-top.jpg'
import gardenCombo from './gardenCombo.jpg'
import youngGardenPlants from './youngGardenPlants.jpg'
import aaiAnimated from './aaiAnimated.gif'
import aai from './aai.png'
import aaiModal from './aaiModal.png'
import aaiDraw from './aaiDraw.png'
import parisStory from './ParisStory2.png'
import postgres from './postgres.svg'
import react from './React-icon.svg'
import d3 from './d3.svg'
import gardenTongueAndGroove from './gardenTongueAndGroove.jpg'
import gardenPlants from './gardenPlants.jpg'
import inkscape from './inkscape.svg'
import gardenEmpty from './gardenEmpty.jpg'
import javascript from './javascript.svg'
import node from './node.svg'
import googlemaps from './googlemaps.svg'
import redux from './redux.svg'
import openlayers from './openlayers.svg'
import linux from './linux.svg'
import python from './python.svg'
import arduino from './arduino.png'
import alice1 from './alice1.JPG'
import alice2 from './alice2.JPG'
import alice3 from './alice3.JPG'
import animatedPostures from './animatedPostures.gif'
import animatedPatternCapture from './patternCapture.gif'
import patternCapture from './patternCapture.png'
import geoSocialSentiment from './geoSocialSentiment.png'
import videoExploit from './videoExploit.png'
import gardenSensor from './gardenSensor.jpg'
import gardenSideLights from './gardenSideLights.jpg'
import cyberLevel from './cyberLevel.jpg'
import dynamicResults from './dynamicResults2.png'
import posture1 from './posture1.jpg'
import posture2 from './posture2.jpg'
import posture3 from './posture3.jpg'
import posture4 from './posture4.jpg'
import posture5 from './posture5.jpg'
import threedsystems from './3ds.png'
import geoTemporalDataFinder from './geoTemporalDataFinder2.png'
import leaflet from './leaflet.jpg'
import postgis from './postgis.png'
import java from './java.svg'
import deskDraft1 from './deskDraft1.jpg'
import deskDraft2 from './deskDraft2.jpg'
import deskDraft3 from './deskDraft3.jpg'
import geoSocialSentimentSimple from './geoSocialSentimentSimple.png'
import table1 from './Table1.jpg'
import table2 from './Table2.jpg'
import tableRender from './tableRender.png'

import zw_closeup from './zerowaste/3dView9.10.jpg'
import zw_journeymap from './zerowaste/JourneyMaps2.jpg'
import zw_projectboard from './zerowaste/Project1Board.jpg'
import zw_foammock from './zerowaste/FoamMock.jpg'
import zw_wood from './zerowaste/WoodWorkingProgress1.jpg'
import zw_firstlight from './zerowaste/FirstLight.jpg'
// import zw_oz from './zerowaste/OzSetup.jpg'
import zw_oz from './zerowaste/WizardOfOz2.JPG'
import zw_physicalproduct from'./zerowaste/ModelPhoto1.jpg'
// import zw_physicalproduct from'./zerowaste/PhysicalProduct.jpg'
import zw_needfinding from './zerowaste/NeedFindingMachine.PNG'
import zw_dial_iterations from './zerowaste/dial_iterations.JPG'

import ipd503_SectionCut from './ipd503/SectionCut.png'
import ipd503_MultipleUses from './ipd503/MultipleUses.png'
import ipd503_pd1 from './ipd503/tm1.jpg'
import ipd503_pd2 from './ipd503/tm2.jpg'
import ipd503_pd3 from './ipd503/tm3.jpg'
import ipd503_pd4 from './ipd503/tm4.jpg'

import pennappsF18_CleanerPath from './PennAppsF18/CleanerPath.png'
import pennappsF18_Process from './PennAppsF18/process.jpg'
import pennappsF18_Arrived from './PennAppsF18/arrived.png'

import bc_cover from './ipd552/bc_cover.png'
import bc_cover_inner from './ipd552/bc_cover_inner.png'
import bc_stock_patient_man from './ipd552/stock_patient_man.png'
import bc_journey_map from './ipd552/journeymap.JPG'
import bc_terminology from './ipd552/bc_terminology.JPG'
import bc_risk from './ipd552/bc_risk_factors.JPG'
import bc_dashboard from './ipd552/bc_dashboard.png'

import AmznPredictionsCover from './PredictingAmznReviews.JPG'

import lasercutting from './laser.png'
import keyshot from './keyshot.png'
import rhino from './Rhino.png'


export default {
    AmznPredictionsCover,
    bc_cover,
    bc_cover_inner,
    bc_stock_patient_man,
    bc_journey_map,
    bc_terminology,
    bc_risk,
    bc_dashboard,
    linkedinMark,
    githubMark,
    rhino,
    lasercutting,
    keyshot,
    pennappsF18_CleanerPath,
    pennappsF18_Process,
    pennappsF18_Arrived,
    ipd503_SectionCut,
    ipd503_MultipleUses,
    ipd503_pd1,
    ipd503_pd2,
    ipd503_pd3,
    ipd503_pd4,
    zw_needfinding,
    zw_physicalproduct,
    zw_oz,
    zw_firstlight,
    zw_wood,
    zw_foammock,
    zw_projectboard,
    zw_journeymap,
    zw_closeup,
    zw_dial_iterations,
    table1,
    table2,
    tableRender,
    geoSocialSentimentSimple,
    deskDraft1,
    deskDraft2,
    deskDraft3,
    leaflet,
    postgis,
    java,
    geoTemporalDataFinder,
    threedsystems,
    threedsystemsprojet: threedsystems,
    posture1,
    posture2,
    posture3,
    posture4,
    posture5,
    dynamicResults,
    cyberLevel,
    gardenSideLights,
    gardenSensor,
    videoExploit,
    wordPortraitThumb,
    districtIso,
    districtTop,
    gardenCombo,
    youngGardenPlants,
    gardenPlants,
    gardenTongueAndGroove,
    aai,
    aaiDraw,
    aaiModal,
    aaiAnimated,
    parisStory,
    gardenEmpty,
    postgres,
    react,
    inkscape,
    d3,
    javascript,
    node,
    googlemaps,
    redux,
    openlayers,
    linux,
    python,
    arduino,
    alice1,
    alice2,
    alice3,
    multiModalFlat,
    deskRenderIso,
    animatedPostures,
    animatedPatternCapture,
    patternCapture,
    geoSocialSentiment
}



// WEBPACK FOOTER //
// ./src/images/index.js